import { jsxs as a, jsx as i } from "react/jsx-runtime";
import { Chains as x } from "porto";
import { useContext as g, createContext as w, Children as u } from "react";
import y from "../_virtual/refresh-cw.js";
import { ButtonArea as _ } from "../ButtonArea/ButtonArea.js";
import { ChainIcon as C } from "../ChainIcon/ChainIcon.js";
import { Spinner as N } from "../Spinner/Spinner.js";
import { TokenIcon as k } from "../TokenIcon/TokenIcon.js";
import { cx as h } from "../apps/ui/styled-system/css/cx.js";
import { css as e } from "../apps/ui/styled-system/css/css.js";
function f({
  amount: t,
  chainId: o,
  className: s,
  fetching: l = !1,
  onRefetch: d,
  amountFiat: n,
  tokenSymbol: c,
  tokenName: p,
  warn: v = !1
}) {
  const r = g(f.Group.Context), m = x.all.find((b) => b.id === o);
  return /* @__PURE__ */ a(
    "div",
    {
      className: h(
        e({
          alignItems: "center",
          backgroundColor: "var(--background-color-th_field)",
          display: "flex",
          gap: 16,
          height: 54,
          paddingLeft: 12
        }),
        e({
          border: "1px solid var(--border-color-th_field)"
        }),
        r ? e({
          borderRadius: 0,
          borderTopWidth: 0
        }) : e({
          borderRadius: "var(--radius-th_medium)"
        }),
        (r == null ? void 0 : r.isFirst) && e({
          borderTopLeftRadius: "var(--radius-th_medium)",
          borderTopRightRadius: "var(--radius-th_medium)",
          borderTopWidth: 1
        }),
        (r == null ? void 0 : r.isLast) && e({
          borderBottomLeftRadius: "var(--radius-th_medium)",
          borderBottomRightRadius: "var(--radius-th_medium)"
        }),
        s
      ),
      children: [
        /* @__PURE__ */ a(
          "div",
          {
            className: e({
              flexShrink: 0,
              position: "relative"
            }),
            children: [
              /* @__PURE__ */ i(k, { size: 20, symbol: c }),
              /* @__PURE__ */ i(
                C,
                {
                  border: !0,
                  chainId: o,
                  className: e({
                    left: 12,
                    position: "absolute",
                    top: 12
                  }),
                  size: 14
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ a(
          "div",
          {
            className: e({
              display: "flex",
              flex: 1,
              flexDirection: "column",
              height: "100%",
              justifyContent: "center",
              minWidth: 0,
              paddingBlock: 8
            }),
            children: [
              /* @__PURE__ */ i(
                "div",
                {
                  className: e({
                    alignItems: "center",
                    display: "flex",
                    justifyContent: "space-between"
                  }),
                  children: /* @__PURE__ */ i(
                    "div",
                    {
                      className: e({
                        color: "var(--text-color-th_base)",
                        fontSize: 14,
                        fontWeight: 500,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap"
                      }),
                      title: p,
                      children: p
                    }
                  )
                }
              ),
              /* @__PURE__ */ a(
                "div",
                {
                  className: e({
                    color: "var(--text-color-th_base-secondary)",
                    fontSize: 11,
                    fontWeight: 400,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap"
                  }),
                  children: [
                    "on ",
                    (m == null ? void 0 : m.name) || `Chain ${o}`
                  ]
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ a(
          _,
          {
            className: e({
              alignItems: "center",
              borderRadius: "var(--radius-th_medium)",
              display: "flex",
              flexShrink: 0,
              gap: 8,
              height: "100%",
              marginLeft: "auto",
              paddingInline: 12
            }),
            disabled: !d || l,
            onClick: d,
            style: { outlineOffset: -1 },
            children: [
              /* @__PURE__ */ i(
                "div",
                {
                  className: e({
                    alignItems: "flex-end",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    minWidth: 0,
                    paddingBlock: 8
                  }),
                  children: /* @__PURE__ */ i(
                    "div",
                    {
                      className: h(
                        e({
                          fontSize: 14,
                          fontWeight: 500,
                          overflow: "hidden",
                          textAlign: "right",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap"
                        }),
                        v ? e({ color: "var(--text-color-th_base-warning)" }) : e({ color: "var(--text-color-th_base)" })
                      ),
                      title: `${n} (${t})`,
                      children: n
                    }
                  )
                }
              ),
              /* @__PURE__ */ i(
                "div",
                {
                  className: e({
                    alignItems: "center",
                    backgroundColor: "var(--background-color-th_base-alt)",
                    borderRadius: "50%",
                    display: "flex",
                    flexShrink: 0,
                    height: 20,
                    justifyContent: "center",
                    position: "relative",
                    width: 20
                  }),
                  children: /* @__PURE__ */ i(
                    "div",
                    {
                      className: e({
                        display: "grid",
                        inset: 0,
                        placeItems: "center",
                        position: "absolute"
                      }),
                      title: l ? "Fetching balance…" : void 0,
                      children: l ? /* @__PURE__ */ i(
                        N,
                        {
                          color: "var(--text-color-th_base-secondary)",
                          size: 12,
                          thickness: 1
                        }
                      ) : /* @__PURE__ */ i(
                        y,
                        {
                          className: e({
                            color: "var(--text-color-th_base-secondary)",
                            height: 12,
                            width: 12
                          })
                        }
                      )
                    }
                  )
                }
              )
            ]
          }
        )
      ]
    }
  );
}
((t) => {
  function o({ children: s, className: l }) {
    const d = u.count(s);
    return /* @__PURE__ */ i(
      "div",
      {
        className: h(
          e({
            display: "flex",
            flexDirection: "column"
          }),
          l
        ),
        children: u.map(s, (n, c) => /* @__PURE__ */ i(
          t.Group.Context.Provider,
          {
            value: {
              isFirst: c === 0,
              isLast: c === d - 1
            },
            children: n
          }
        ))
      }
    );
  }
  t.Group = o, ((s) => {
    s.Context = w(null);
  })(o = t.Group || (t.Group = {}));
})(f || (f = {}));
export {
  f as Balance
};
//# sourceMappingURL=Balance.js.map
